export default class ArrayUtil {
    /**
     * Function for Arrays of comparable (== and <, i.e. numbers and strings) that assumes the array is already SORTED.
     *
     * @param q the key to search for
     *
     * @return (int) If the array contains key, returns the index of any occurrence of key; otherwise returns -1.
     */
    binarySearch(array: any[], q: any) {
        let mid, lower = 0, upper = array.length;
        while (lower <= upper) {
            mid = Math.floor((lower + upper) / 2);

            if (q == array[mid]) {
                return mid;
            }

            if (q < array[mid]) {
                upper = mid - 1;
            } else {
                lower = mid + 1;
            }
        }
        
        return -1;
    }

    /**
     * Function for Arrays of objects that assumes the array is already SORTED BY THE PROPERTY WHICH IS BEING SEARCHED BY.
     *
     * e.g. Assuming array is [{id:0, val: "a"}, {id:1, val: "b"}, {id:2, val: "c"}, {id:3, val: "d"}, {id:4, val: "e"}, {id:5, val: "f"}]
     *      es.util.array.binarySearchGet(array, "val", "e") returns {id:4, val: "e"}
     *      es.util.array.binarySearchGet(array, "id", 4) returns {id:4, val: "e"}
     *      es.util.array.binarySearchGet("id", 404) returns null
     *
     * @param array the array
     * @param prop a property of the array
     * @param val the value of the given property (comparable with === and <, i.e. number or string)
     *
     * @return (object) If the array contains an entry with the prop value, returns object with the occurrence; otherwise returns null.
     */
    binarySearchGet(array: any[], prop: string, val: any) {
        let mid, lower = 0, upper = array.length;
        while (lower <= upper) {
            mid = Math.floor((lower + upper) / 2);

            if (array[mid] === undefined) {
                return null;
            }

            if (val == array[mid][prop]) {
                return array[mid];
            }

            if (val < array[mid][prop]) {
                upper = mid - 1;
            } else {
                lower = mid + 1;
            }
        }

        return null;
    }

    /**
     * Checks if an array includes all elements of another array
     *
     * @param array array to check if includes all elements
     * @param elements array of elements to check for
     * @return (boolean) true if the array contains all the elements
     */
    includesAll(array: any[], elements: any[]) {
        for (let i = 0; i < elements.length; i++) {
            if (!array.includes(elements[i])) {
                return false;
            }
        }

        return true;
    };

    /**
     * Checks if 2 arrays have the same elements in the same order
     * 
     * @param {Array} array1 
     * @param {Array} array2 
     */
    equals(array1: any[], array2: any[]) {
        if (array1 === array2) {
            return true;
        }

        if (array1.length !== array2.length) {
            return false;
        }

        for (let i = 0; i < array1.length; i++) {
            if (array1[i] !== array2[i]) {
                return false;
            }
        }

        return true;
    }
}
